"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavTreeNode = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const lib_1 = require("../../../lib");
const elements_1 = require("../../../elements");
const NavItem_1 = require("./NavItem");
const FileSystem_1 = require("../../FileSystem");
const FileSystemContext_1 = require("../../FileSystem/FileSystemContext");
const NavTreeNode = ({ open, level, item, onClick, onOpen, onClose, children, label, active, noOpen }) => {
    const [state, setState] = (0, react_1.useState)({
        isHovering: false
    });
    const handleCollapseClick = (0, react_1.useCallback)((event) => {
        event.stopPropagation();
        if (open && onClose)
            onClose();
        if (!open && onOpen)
            onOpen();
    }, [onClose, onOpen, open]);
    const handleHoverStart = (0, react_1.useCallback)(() => {
        setState(state => (Object.assign(Object.assign({}, state), { isHovering: true })));
        setTimeout(() => {
            setState(state => {
                if (state.isHovering && !open && onOpen) {
                    onOpen();
                }
                return state;
            });
        }, 500);
    }, [setState, open, onOpen]);
    const handleHoverEnd = (0, react_1.useCallback)(() => {
        setState(state => (Object.assign(Object.assign({}, state), { isHovering: false })));
    }, [setState]);
    const { state: { openItem } } = (0, react_1.useContext)(FileSystemContext_1.FileSystemContext);
    const handleClick = (0, react_1.useCallback)(() => {
        if (onClick)
            onClick(item);
    }, [onClick]);
    const child = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [Array.from(Array(level).keys()).map((v, idx) => ((0, jsx_runtime_1.jsx)("div", { className: "item-tree__spacer" }, idx))), !noOpen && ((0, jsx_runtime_1.jsx)(elements_1.Icon, { onClick: handleCollapseClick, name: open ? 'caretDown' : 'caretRight' }, void 0)), noOpen && (0, jsx_runtime_1.jsx)("div", { className: "w--1" }, void 0), (0, jsx_runtime_1.jsx)(elements_1.Icon, { className: "nav__item-icon", name: "folder" }, void 0), label || children] }, void 0));
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "nav__item-tree item-tree" }, { children: [item && ((0, jsx_runtime_1.jsx)(FileSystem_1.Folder, Object.assign({ item: item, onHoverStart: handleHoverStart, onHoverEnd: handleHoverEnd, disableContextMenu: true, disableDrag: true }, { children: ({ canDrop, isOver }) => ((0, jsx_runtime_1.jsx)(NavItem_1.NavItem, Object.assign({ tree: true, canDrop: canDrop, isOver: isOver, active: openItem ? item.id === openItem.id : false, onClick: handleClick }, { children: child }), void 0)) }), void 0)), !item && ((0, jsx_runtime_1.jsx)(NavItem_1.NavItem, Object.assign({ tree: true, onClick: handleClick, active: active }, { children: child }), void 0)), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, lib_1.bem)('item-tree__children', (0, lib_1.use)(open, '--is-open')) }, { children: children }), void 0)] }), void 0));
};
exports.NavTreeNode = NavTreeNode;
//# sourceMappingURL=NavTreeNode.js.map